import React, { useState, useEffect, useRef } from 'react';
import { pushToDataLayer } from '@jbhi-fi/utils/src/ga4Tracking/datalayer';

type PriceRangeDropdownShellProps = {
  nbHits: number;
  isRefined: boolean;
  currentMin: number;
  currentMax: number;
  searchTerm: string;
  children: React.ReactNode | ((showDropdown: boolean) => React.ReactNode);
};

const PriceRangeDropdownShell = ({
  nbHits,
  isRefined,
  currentMin,
  currentMax,
  searchTerm,
  children,
}: PriceRangeDropdownShellProps) => {
  const refineDropdown = useRef<HTMLDivElement>(null);
  const refineButton = useRef<HTMLButtonElement>(null);
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    const handleExternalClick = (event: MouseEvent) => {
      const dd = refineDropdown.current;
      const btn = refineButton.current;
      if (dd && !dd.contains(event.target as Node) && btn && !btn.contains(event.target as Node)) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.body.addEventListener('click', handleExternalClick);
    }
    return () => {
      document.body.removeEventListener('click', handleExternalClick);
    };
  }, [showDropdown]);

  const toggleDropdown = (event: React.MouseEvent) => {
    event.preventDefault();
    pushToDataLayer({
      event: 'open_filter_group',
      filter_group: 'price',
      search_type: 'suggested search',
      search_term: searchTerm,
    });
    setShowDropdown(v => !v);
  };

  return (
    <div className="search-price-range">
      <button
        type="button"
        ref={refineButton}
        className={`search-price-range-button${showDropdown ? ' active' : ''}${isRefined ? ' active' : ''}`}
        onClick={toggleDropdown}
      >
        {!isRefined ? 'Price range' : `$${currentMin} - $${currentMax}`}
      </button>
      <div
        ref={refineDropdown}
        className={`search-price-range-dropdown scoped-form-styles ${showDropdown && 'active'}`}
      >
        <div className="resultNum">
          {nbHits} result{nbHits !== 1 ? 's' : ''}
        </div>
        {typeof children === 'function' ? children(showDropdown) : children}
        <button type="submit" className="search-price-range-dropdown--search">
          Search
        </button>
      </div>
    </div>
  );
};

export default PriceRangeDropdownShell;
